import React, { useState } from "react";
import QuoteNavbar from "../../../Components/Desktop/QuoteNavbar/QuoteNavbar";
import { Box, Link } from "@mui/material";
import Grid from "@mui/material/Unstable_Grid2";
import "../../../CommonScss/QuotePage.scss";
import CustomButton from "../../../Components/Common/CustomButton/CustomButton";
import GreyDetailBox from "./GreyDetailBox/GreyDetailBox";
import { useNavigate } from "react-router-dom";
import { PATH } from "../../../shared/Path";

function QuotePage() {
  const navigate = useNavigate();
  const planData = [
    { title: "Accidental Death", amount: "$10,000", deductible: "Nil" },
    {
      title: "Loss of Baggage & Personal Documents",
      amount: "$200",
      deductible: "Nil",
    },
    { title: "Personal Liability", amount: "$200", deductible: "Nil" },
  ];
  const insuranceData = [
    { text: "Loss of Passport", amount: "$300" },
    { text: "Trip Delay Cover", amount: "" },
    { text: "Baggage Loss Cover", amount: "$100" },
  ];
  const coverageData = [
    {
      text: "Accidental Death 4 Hours",
      amount: "$50,000",
      deductible: "Deductible: Nil",
    },
    {
      text: "24 Hours Dismemberment",
      amount: "$50,000",
      deductible: "Deductible: Nil",
    },
    {
      text: "Medical Evacuation for Emergency",
      amount: "$1,50,000",
      deductible: "Deductible: $100 for each claim",
    },
    {
      text: "Medical Expenses for Accident and Sickness",
      amount: "$1,50,000",
      deductible: "Deductible: $100 for each claim",
    },
    {
      text: "Emergency Dental Expenses - Relief of Pain",
      amount: "$250",
      deductible: "Policy Excess: 24 Hours",
    },
    {
      text: "In Hospital Benefits (USD $20.00 per day)",
      amount: "$200",
      deductible: "Policy Excess: Nil",
    },
    {
      text: "Medicines (Prescription Required)",
      amount: "$1,000",
      deductible: "Deductible: Nil",
    },
    { text: "Trip Delay", amount: "$500", deductible: "Policy Excess: Nil" },
    {
      text: "Emergency Family Travel Ticket",
      amount: "$300",
      deductible: "Policy Excess: Nil",
    },
    {
      text: "Public Liability",
      amount: "$1,50,000",
      deductible:
        "Deductable: $20 for each loss in respect of Third-Party Property Damage",
    },
    {
      text: "Return of Minor Child/Children",
      amount: "$1,000",
      deductible: "Deductable: Nil",
    },
    {
      text: "Lost Luggage",
      amount: "$2,000",
      deductible: "Deductable: $100 for each claim",
    },
    {
      text: "Baggage Delay",
      amount: "$150",
      deductible: "Policy Excess: 12 hours",
    },
    {
      text: "Death Repatriation",
      amount: "$300",
      deductible: "Deductable: Nil",
    },
    { text: "Bail Bond", amount: "$1,000", deductible: "Deductable: Nil" },
    { text: "Legal Fees", amount: "$1,000", deductible: "Deductable: Nil" },
    {
      text: "Worldwide Assistance 24 hours",
      amount: "Included",
      deductible: "Deductable: Nil",
    },
  ];

  return (
    <Box className="quoteWrapper">
      <QuoteNavbar />
      <Grid container spacing={3}>
        <Grid xs maxWidth="300px">
          <div className="ctaBtn mb-4">
            <CustomButton
              class_name="backBtn"
              text_name="Back"
              onClickFunction={() => {
                navigate(-1);
              }}
            />
          </div>
          <Box className="lefSidebar">
            <h4>Additional Covers</h4>
            <Box className="whiteBox">
              <p>What you need to purchase:</p>
              <ol>
                <li>Passports of all travellers.</li>
                <li>Covid Vaccination/RT - PCR test report.</li>
                <li>Personal information of all travellers.</li>
                <li>Your travel iterniary.</li>
              </ol>
            </Box>
          </Box>
        </Grid>
        <Grid xs display="flex" flexDirection="column" gap="24px">
          {/* Travellers Details */}
          <Box
            className="travellerDetails"
            width="100%"
            display="flex"
            gap="24px"
            alignItems="center"
          >
            <Grid
              container
              columnSpacing={3}
              borderRadius="16px"
              flex="1"
              padding="20px"
              sx={{ background: "#F4F3FF" }}
            >
              <Grid lg={6} xs={12} display="flex" gap="12px">
                <div className="flex-1">
                  <p>Travellers</p>
                  <h6>2 Members</h6>
                </div>
                <div className="flex-1">
                  <p>Travelling to</p>
                  <h6>Canada, England</h6>
                </div>
              </Grid>
              <Grid lg={6} xs={12} display="flex" gap="12px">
                <div className="flex-1">
                  <p>Departure</p>
                  <h6>Dec 1, 2023</h6>
                </div>
                <div className="flex-1">
                  <p>Return</p>
                  <h6>Dec 12, 2023</h6>
                </div>
              </Grid>
            </Grid>
            <div className="ctaBtn">
              <CustomButton text_name="Modify" class_name="blueMdBtn" />
            </div>
          </Box>

          {/* Plan Details */}
          <Box className="planDetails">
            <Grid container>
              <Grid xs={6}>
                <h4 style={{ fontWeight: "500" }}>Plan Details:</h4>
              </Grid>
              <Grid xs={6} textAlign={"right"}>
                <Link>Need help?</Link>
              </Grid>
            </Grid>
            <Box
              border={"1px solid #6458D8"}
              display="flex"
              flexDirection="column"
              alignItems="flex-start"
              alignSelf="stretch"
              gap="12px"
              borderRadius="20px"
              width="100%"
              overflow="hidden"
              marginTop="24px"
              paddingBottom="12px"
            >
              <Grid
                container
                columnSpacing={3}
                alignItems="center"
                width="100%"
                className="blueStrip"
                padding="12px!important"
              >
                <Grid xs={6}>
                  <h5>Worldwide Travel Policy</h5>
                </Grid>
                <Grid
                  xs={6}
                  display="flex"
                  alignItems="center"
                  gap="12px"
                  justifyContent="end"
                  textAlign={"right"}
                >
                  <h4>₹ 1,024</h4>
                  <p>+ Taxes</p>
                  <span className="ctaBtn">
                    <CustomButton
                      class_name="whiteXlBtn"
                      onClickFunction={() => {
                        navigate(PATH.PROPOSAL_PAGE);
                      }}
                      text_name="Buy Now"
                    />
                  </span>
                </Grid>
              </Grid>
              <Grid
                container
                width="100%"
                columnSpacing={3}
                justifyContent="center"
                rowGap="12px"
              >
                {planData.map((item, index) => (
                  <Grid key={index} lg={4} md={6} xs={12}>
                    <GreyDetailBox
                      title={item.title}
                      amount={item.amount || "N/A"} // Handle empty amount
                      deductible="Nil"
                    />
                  </Grid>
                ))}
              </Grid>
              <Grid container columnSpacing={3} width="100%">
                <Grid xs textAlign={"right"}>
                  <p style={{ fontSize: "12px" }}>*Deductible</p>
                </Grid>
              </Grid>
              <Grid container columnSpacing={3} width="100%">
                <Grid
                  xs={12}
                  sx={{
                    background: "#F4F3FF",
                    padding: "20px",
                    margin: "0px 12px",
                    borderRadius: "0px 0px 16px 16px",
                  }}
                >
                  <ul
                    style={{
                      display: "flex",
                      gap: "32px",
                      marginLeft: "12px",
                      flexWrap: "wrap",
                    }}
                  >
                    {insuranceData.map((item, index) => (
                      <li
                        key={index}
                        style={{
                          listStyleType: "initial",
                          fontWeight: "700",
                          fontSize: "14px",
                          color: "#6458D8",
                        }}
                      >
                        {item.text} {item.amount && <span>{item.amount}</span>}
                      </li>
                    ))}
                  </ul>
                </Grid>
              </Grid>
            </Box>
          </Box>

          {/* Coverage Details */}
          <Grid container width={"100%"}>
            <Grid xs={12}>
              <h4 style={{ fontWeight: "500" }}>Coverage Details:</h4>
            </Grid>
          </Grid>
          <Grid container columnSpacing={3} width="100%">
            <Grid
              xs={12}
              sx={{
                background: "#F4F3FF",
                padding: "20px",
                borderRadius: "16px",
              }}
            >
              <h5
                style={{
                  fontSize: "18px",
                  fontWeight: "600",
                  marginBottom: "24px",
                  color: "#6458D8",
                }}
              >
                List of Benefits:
              </h5>
              <ul
                style={{
                  display: "flex",
                  gap: "24px",
                  marginLeft: "4px",
                  flexWrap: "wrap",
                }}
              >
                {coverageData.map((item, index) => (
                  <li
                    key={index}
                    style={{
                      flex: "1 0 0",
                      minWidth: "342px",
                      borderBottom: "1px solid #DADADA",
                      paddingBottom: "16px",
                    }}
                  >
                    <p style={{ fontSize: "14px", fontWeight: "500" }}>
                      {item.text}
                    </p>
                    <h6 style={{ fontSize: "14px", fontWeight: "700" }}>
                      {item.amount}{" "}
                      <span
                        style={{
                          fontSize: "12px",
                          fontWeight: "500",
                          opacity: "0.7",
                          marginLeft: "8px",
                        }}
                      >
                        {item.deductible}
                      </span>
                    </h6>
                  </li>
                ))}
              </ul>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </Box>
  );
}

export default QuotePage;
